module.exports = __webpack_public_path__ + "img/1.7f79bca2.png";